export default __webpack_public_path__ + "static/media/1347.c3007e4c.png";